import * as React from 'react';
import { Features, FeaturesMobile } from '../../components/Features';
import { useSelector } from 'react-redux';
import { selectFeatures } from '../../selectors';
import { useDeviceType } from '@cian/ui-kit';

export const FeaturesContainer = () => {
  const deviceType = useDeviceType();
  const features = useSelector(selectFeatures);

  if (!features.length) {
    return null;
  }

  const FeaturesComponent = deviceType === 'desktop' ? Features : FeaturesMobile;

  return <FeaturesComponent features={features} />;
};
